export default {
  HOVER: 'Hover',
  DISABLED: 'Disabled',
  LOADING: 'Loading',
  READY: 'Ready',
  SAVING: 'Saving',
  ERROR: 'Error',
} as const;
